<template>
  <div>
    <p>{{ trans('series.save_explanation') }}</p>

    <div
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="goal_name"
      >{{ trans('series.name_goal') }}</label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <input
          id="goal_name"
          v-model="goalName"
          class="col-sm-9 form-group form-control"
        >
      </div>
    </div>

    <div
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="visible_for_students"
      >{{ trans('series.visible_for_student') }}</label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <input
          id="visible_for_students"
          v-model="visibleForStudents"
          type="checkbox"
          class="col-sm-9"
          style="width: auto"
        >
      </div>
      <small style="padding-left: 15px">{{ trans('series.visible_for_student_explanation') }}</small>
    </div>

    <div
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="notifications_enabled"
      >{{ trans('series.send_notifications') }}</label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <input
          id="notifications_enabled"
          v-model="notificationsEnabled"
          type="checkbox"
          class="col-sm-9"
          style="width: auto"
        >
      </div>
      <small style="padding-left: 15px">{{ trans('series.send_notifications_explanation') }}</small>
    </div>

    <div
      v-if="notificationsEnabled"
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="cluster_failed_message"
      >
        {{ trans('notification.event_cluster_failed.cluster_failed.additional_message') }}
      </label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <textarea
          id="cluster_failed_message"
          v-model="clusterFailedMessage"
          rows="3"
          class="col-sm-9 form-group form-control"
        />
      </div>
    </div>

    <div
      v-if="notificationsEnabled"
      class="col-sm-12"
      style="display: inline-block; margin-bottom: 10px;"
    >
      <label
        class="col-sm-3"
        style="margin-top: 15px;"
        for="goal_failed_message"
      >
        {{ trans('notification.event_cluster_failed.goal_failed.additional_message') }}
      </label>
      <div
        class="col-sm-9"
        style="padding-right: 0;"
      >
        <textarea
          id="goal_failed_message"
          v-model="goalFailedMessage"
          rows="3"
          class="col-sm-9 form-group form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SaveGoal',

  computed: {
    goalName: {
      get () {
        return this.$store.state.eventSeries.serie_rules.goal_name
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'goal_name', value: newValue })
      },
    },
    visibleForStudents: {
      get () {
        return this.$store.state.eventSeries.serie_rules.visible_for_students
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'visible_for_students', value: newValue })
      },
    },
    notificationsEnabled: {
      get () {
        return this.$store.state.eventSeries.serie_rules.notifications_enabled
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'notifications_enabled', value: newValue })
      },
    },
    clusterFailedMessage: {
      get () {
        return this.$store.state.eventSeries.serie_rules.cluster_failed_message
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'cluster_failed_message', value: newValue })
      },
    },
    goalFailedMessage: {
      get () {
        return this.$store.state.eventSeries.serie_rules.goal_failed_message
      },
      set (newValue) {
        return this.$store.dispatch('update_serie_rules', { rule: 'goal_failed_message', value: newValue })
      },
    },
  },

  watch: {
    goalName: function (newValue) {
      const finished = this.$store.state.steps.steps_info[3].finished
      if (!finished && (newValue !== '' || newValue == null)) {
        return this.$emit('canFinishStep')
      }
      if (finished && (newValue === '' || newValue == null)) {
        return this.$emit('canNotFinishStep')
      }
    },
  },
}
</script>

<style>

</style>
